module.exports = __webpack_public_path__ + "media/images/metronic/loading-18b3e34c34be43e0065321fe3190c8ff.gif";